// Test IDs for the new Phase 1 public pages (About, Get Involved, Stories,
// Events, Contact, Portal Preview stub). These pages are structural front-door
// content only — no private data, no activation logic.

export const PUBLIC_ABOUT = {
  page: 'about-page',
  hero: 'about-hero',
  mission: 'about-mission',
  impact: 'about-impact',
  impactStat: 'about-impact-stat',
  philosophy: 'about-philosophy',
  cta: 'about-cta',
};

export const PUBLIC_GET_INVOLVED = {
  page: 'get-involved-page',
  hero: 'get-involved-hero',
  pathwayCard: 'get-involved-pathway-card',
  buddyCta: 'get-involved-buddy-cta',
  volunteerCta: 'get-involved-volunteer-cta',
  partnerCta: 'get-involved-partner-cta',
  donateCta: 'get-involved-donate-cta',
};

export const PUBLIC_STORIES = {
  page: 'stories-page',
  hero: 'stories-hero',
  featured: 'stories-featured',
  emptyState: 'stories-empty-state',
  shareCta: 'stories-share-cta',
  provenanceNote: 'stories-provenance-note',
};

export const PUBLIC_EVENTS = {
  page: 'events-page',
  hero: 'events-hero',
  list: 'events-list',
  emptyState: 'events-empty-state',
  notifyCta: 'events-notify-cta',
};

export const PUBLIC_CONTACT = {
  page: 'contact-page',
  hero: 'contact-hero',
  form: 'contact-form',
  name: 'contact-name',
  email: 'contact-email',
  subject: 'contact-subject',
  message: 'contact-message',
  submit: 'contact-submit',
  supportLink: 'contact-support-link',
};

export const PUBLIC_PORTAL_PREVIEW = {
  page: 'portal-preview-page',
  hero: 'portal-preview-hero',
  comingSoonBadge: 'portal-preview-coming-soon',
  homeCta: 'portal-preview-home-cta',
  joinCta: 'portal-preview-join-cta',
  supportCta: 'portal-preview-support-cta',
  banner: 'portal-preview-banner',
  tab: 'portal-preview-tab',
  tabDashboard: 'portal-preview-tab-dashboard',
  tabMessaging: 'portal-preview-tab-messaging',
  tabCommunity: 'portal-preview-tab-community',
  tabResources: 'portal-preview-tab-resources',
  tabEvents: 'portal-preview-tab-events',
  tabHospitals: 'portal-preview-tab-hospitals',
  tabVolunteer: 'portal-preview-tab-volunteer',
  tabSupport: 'portal-preview-tab-support',
  panelDashboard: 'portal-preview-panel-dashboard',
  panelMessaging: 'portal-preview-panel-messaging',
  panelCommunity: 'portal-preview-panel-community',
  panelResources: 'portal-preview-panel-resources',
  panelEvents: 'portal-preview-panel-events',
  panelHospitals: 'portal-preview-panel-hospitals',
  panelVolunteer: 'portal-preview-panel-volunteer',
  panelSupport: 'portal-preview-panel-support',
  ctaJoin: 'portal-preview-cta-join',
  ctaSupport: 'portal-preview-cta-support',
  ctaExit: 'portal-preview-cta-exit',
};

export const PUBLIC_NAV = {
  navHome: 'public-nav-home',
  navAbout: 'public-nav-about',
  navGetInvolved: 'public-nav-get-involved',
  navSupport: 'public-nav-support',
  navStories: 'public-nav-stories',
  navEvents: 'public-nav-events',
  navContact: 'public-nav-contact',
};
